import {
	ReservedVehicleResponse,
	ReservedStatus,
	ReserveTimeLimit,
	DepositAmount,
	Status,
	SubmitErrorMessage,
} from '@/types/reserve-vehicle';

export class ReserveVehicleState {
	status: Status | string = '';

	isLoading = false;

	isDisplayWidget = false;

	reserveVehicleResponse: ReservedVehicleResponse | null = null;

	isReserveVehicle: ReservedStatus | boolean = false;

	reserveTimeLimit: ReserveTimeLimit | number = 0;

	depositAmount: DepositAmount | number = 0;

	isFormError = true;

	submitErrorMessage: SubmitErrorMessage | string = '';
}
